import { createSlice } from "@reduxjs/toolkit";

const gridLayoutSlice = createSlice({
  name: "gridLayout",
  initialState: [],
  reducers: {
    saveState(state, action) {
      let currentGrid = state.find(
        (grid) => grid.gridName === action.payload.gridName
      );

      //initialize grid state if not found
      if (!currentGrid) {
        state.push({
          gridName: action.payload.gridName,
          state: action.payload.state,
        });
      } else {
        currentGrid.state = action.payload.state;
      }
    },
    deleteState(state, action) {
      state = [...state.filter((x) => x.gridName !== action.payload.gridName)];
    },
  },
});

export const gridLayoutActions = gridLayoutSlice.actions;
export default gridLayoutSlice.reducer;
